import { P, T3, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentsState } from '../../../../interfaces/DocumentsState';
import { StyledDocumentsIcon, StyledList, StyledListItem, StyledListItemText, StyledP } from './NoResults.styles';

export interface NoResultsProps { }

const NoResults: FC<NoResultsProps> = () => {
  const groups = useScopedSelector((state: DocumentsState) => state.groups);
  const { t } = useTranslation('Documents');

  if (groups.some((g) => g.documents.some((d) => d.visible))) return null;

  return (
    <>
      <StyledDocumentsIcon />
      <T3>{t('noResults.title')}</T3>
      <P>{t('noResults.description')}</P><br />
      <StyledP>{t('noResults.suggestions')}</StyledP>
      <StyledList>
        <StyledListItem><StyledListItemText>{t('noResults.suggestion1')}</StyledListItemText></StyledListItem>
        <StyledListItem><StyledListItemText>{t('noResults.suggestion2')}</StyledListItemText></StyledListItem>
        <StyledListItem><StyledListItemText>{t('noResults.suggestion3')}</StyledListItemText></StyledListItem>
      </StyledList>
    </>
  );
};

export default NoResults;
